import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "filter_alt",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2610_5983",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 20,
				height: 20,
				fill: "#D9D9D9",
				style: {
					fill: "#D9D9D9",
					fill: "color(display-p3 0.8510 0.8510 0.8510)",
					fillOpacity: 1
				}
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2610_5983)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "filter_alt_2",
				d: "M9.1669 16.6667C8.93079 16.6667 8.73287 16.5868 8.57315 16.4271C8.41342 16.2674 8.33356 16.0694 8.33356 15.8333V10.8333L3.50023 4.66667C3.2919 4.38889 3.26065 4.09722 3.40648 3.79167C3.55231 3.48611 3.80579 3.33334 4.1669 3.33334H15.8336C16.1947 3.33334 16.4481 3.48611 16.594 3.79167C16.7398 4.09722 16.7086 4.38889 16.5002 4.66667L11.6669 10.8333V15.8333C11.6669 16.0694 11.587 16.2674 11.4273 16.4271C11.2676 16.5868 11.0697 16.6667 10.8336 16.6667H9.1669ZM10.0002 10.25L14.1252 5H5.87523L10.0002 10.25Z",
				fill: "white",
				style: {
					fill: "white",
					fillOpacity: 1
				}
			})
		})]
	})
});
export default SvgFilterAlt;
